import { GridColDef } from "@mui/x-data-grid";
import { LocalizedStrings } from "react-localization";
import { IIntervention } from "../../../components/Site/WFM/_models/Intervention";
import { IInterventionEditFormProps } from "../../../components/Site/WFM/InterventionManagement/InterventionEditForm/InterventionEditForm";
import InterventionEditFormATENA from "./InterventionEditFormATENA";

export const customInterventionColumns = (lang?: LocalizedStrings<any>): GridColDef<IIntervention, number | string | Date>[] => [
    {
        field: 'odi',
        headerName: "P.IVA/CF",
        width: 150
    },
    {
        field: 'witness',
        headerName: lang?.witness,
        width: 200
    },
    {
        field: 'district',
        headerName: lang?.provincia,
    },
];

export const customInterventionEditForm = (props: IInterventionEditFormProps) => <InterventionEditFormATENA {...props} />;